import { Setting, SETTINGS } from 'enum/settings';
import * as z from 'zod';
import { ErrorMessages } from './error-messages';

export const eventSettingsFormSchema = z
  .object({
    startTime: z
      .string()
      .nonempty(ErrorMessages.Required)
      .regex(/(0\d|1[0-2]):[0-5]\d/, ErrorMessages.Time.INVALID),
    startPeriod: z.enum(['AM', 'PM']),
    endTime: z
      .string()
      .nonempty(ErrorMessages.Required)
      .regex(/(0\d|1[0-2]):[0-5]\d/, ErrorMessages.Time.INVALID),
    endPeriod: z.enum(['AM', 'PM']),
    setting: z.nativeEnum(SETTINGS as Record<number, Setting>),
    location: z
      .object({
        venue: z.string().nonempty(ErrorMessages.Required),
        zipCode: z.string().regex(/^\d{5}$/, ErrorMessages.ZipCode.INVALID),
      })
      .optional(),
    facilityId: z.string().optional(),
    facilityRoomArea: z.string().optional(),
    url: z.string().url(ErrorMessages.Url.INVALID).optional(),
  })
  .refine(
    ({ setting, location, url }) => {
      if (setting === SETTINGS[0] && location?.venue && location?.zipCode)
        return true;
      if (setting === SETTINGS[1] && location?.venue && location?.zipCode) return true;
      if (setting === SETTINGS[2] && url) return true;
      return false;
    },
    {
      message: ErrorMessages.Required,
    },
  );

export type EventSettingsForm = z.TypeOf<typeof eventSettingsFormSchema>;
